import { __rest } from "tslib";
import React from 'react';
import { default as sanitizeHtml } from "@pb/utils/common/sanitizeHtml";
import { default as IS_CLIENT } from "@pb/utils/constants/isClient";
import ReactHtmlParser from 'react-html-parser';
import { v4 as uuidv4 } from 'uuid';
const Markup = (_a) => {
    var { input, Tag = 'span', className, sanitized = true, useReactParser = false, onClick } = _a, props = __rest(_a, ["input", "Tag", "className", "sanitized", "useReactParser", "onClick"]);
    const transform = (node, index) => {
        if (node.type === 'tag' && node.name === 'a') {
            return (React.createElement("a", Object.assign({ key: index }, node.attribs, { onClick: onClick, onKeyDown: onClick, tabIndex: 0, role: "link" }), node.children.map((child) => {
                if (child.type === 'tag') {
                    return React.createElement(child.name, { key: uuidv4 }, child.children.map((grandChild) => grandChild.data).join(''));
                }
                return child.data;
            })));
        }
        return undefined;
    };
    const html = sanitized && IS_CLIENT ? sanitizeHtml(input) : input;
    return useReactParser ? (React.createElement(Tag, Object.assign({ className: className }, props), ReactHtmlParser(html, { transform }))) : (React.createElement(Tag, Object.assign({ className: className }, props, { dangerouslySetInnerHTML: {
            __html: html,
        } })));
};
export default Markup;
//# sourceMappingURL=Markup.js.map